import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { IPortfolioOverviewDisplayed } from 'src/models/products.model';
import { DataService } from 'src/data-store/data.service';
import { hideFinancialValues } from 'src/util/constants';

@Component({
  selector: 'liberro-investment-tile',
  standalone: false,
  templateUrl: './liberro-investment-tile.component.html',
  styleUrl: './liberro-investment-tile.component.less'
})
export class LiberroInvestmentTileComponent {
  @Input({required: true}) public investment!: IPortfolioOverviewDisplayed;
  @Input() public type: 'default' | 'investment-select' = 'default';
  @Input() public shareColumns = true;
  @Input() public selected = false;
  @Output() public portfolioSelected = new EventEmitter<number>();
  public investmentTileProfit = hideFinancialValues.investmentTileProfit;
  public investmentTileValue = hideFinancialValues.investmentTileValue;

  public hideFinancialValues = inject(DataService).hideFinancialValues;

  public valueTooltipVisible = signal<boolean>(false);
  public absoluteValueTooltipVisible = signal<boolean>(false);
  public percentTooltipVisible = signal<boolean>(false);

  public selectPortfolio(portfolioId: number): void {
    this.portfolioSelected.emit(portfolioId);
  }
  public valueTooltipToggle(visible: boolean): void {
    this.valueTooltipVisible.set(visible);
  }

  public absoluteValueTooltipToggle(visible: boolean): void {
    this.absoluteValueTooltipVisible.set(visible);
  }

  public percentTooltipToggle(visible: boolean): void {
    this.percentTooltipVisible.set(visible);
  }
}
